const colors = {
  red: '#e53935',
  green: '#4CAF50',
  grey: '#babdbe',
};

export default colors;
